import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design } from '../designTest/designTest.model';
import { DesignSet } from '../edit-questionset/edit-questionset.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { Evaluate } from '../evaluate_marks/evaluate.model';
import { Overall_Result } from '../overall_result/overall_result.model';

export interface QuestionSet {
    Question_Set_Name: string;
}

export interface GenerateSet {
  Question_Set_Id: string;
  Question_Set_Name: string;
}

interface TokenResponse {
  token: string;
}

export interface Pattern {
  pattern: string;
}

export interface Year{
  academic_year:string;
}


export interface audio{
  url:string;
}

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}

@Injectable()
export class YearService {

  private token: string;
  constructor(private http: HttpClient) {}
  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }
  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }
   // display questionset:
   public questionset(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/question_set', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // display questionset:

  // question_set_display
  public question_set_display(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/question_set_display', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


 // edit
 public edit(id): Observable<any> {

  var body = {
    id:id
  }
  const base = this.http.post('/users/edit_question_set', body);
  const request = base.pipe(
    map((data: TokenResponse) => {

      //
      if (data.token) {
        this.saveToken(data.token);
      }
      return data;
    })
  );
  return request;
}

// update
public update(set: Array<DesignSet>): Observable<any> {
  //
  // var body = {
  //   id:id
  // }


  const base = this.http.post('/users/update_question_set', set);
  const request = base.pipe(
    map((data: TokenResponse) => {

      //
      if (data.token) {
        this.saveToken(data.token);
      }
      return data;
    })
  );
  return request;
}


  // delete
  public delete(set: QuestionSet): Observable<any> {

    const base = this.http.post('/users/deleteset', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  //generateSet
  public generateSet(set: Array<DesignSet>): Observable<any> {

    const base = this.http.post('/users/genearateSet', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


// pattern
  public pattern(set: Pattern): Observable<any> {

    var body = {
      id: set
    };
    const base = this.http.post('/users/pattern', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

// schedule

public schedule(item: Array<Schedule>): Observable<any> {

  const b = this.http.post('/users/schedule', item);
  const request = b.pipe(
    map((data: TokenResponse) => {

      // if (data.token) {
      //   this.saveToken(data.token);
      // }
      return data;
    })
  );
  return request;
  }



 // scheduledtest_view

 public scheduledtest_view(item: Array<Schedule>): Observable<any> {

  var body = {
    email: item
  };
  const b = this.http.post('/users/scheduledtest_view', body);
  const request = b.pipe(
    map((data: TokenResponse) => {

      // if (data.token) {
      //   this.saveToken(data.token);
      // }
      return data;
    })
  );
  return request;
  }

  // scheduledtest_viewall
  public scheduledtest_viewall(item: Array<Schedule>): Observable<any> {

    var body = {
      email: item
    };
    const b = this.http.post('/users/scheduledtest_viewall', body);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

  // delete_schedule
  public delete_schedule(item: Array<Schedule>): Observable<any> {

    const base = this.http.post('/users/delete_schedule', item);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // evaluation_details
  public evaluation_details(item: Array<Evaluate>): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/evaluation_details', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

    // evaluate_marks
    public evaluate_marks(item: Array<Evaluate>): Observable<any> {

      // var body = {
      //   email: item
      // };
      const b = this.http.post('/users/evaluate_marks', item);
      const request = b.pipe(
        map((data: TokenResponse) => {

          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
      }

       // evaluate_all
    public evaluate_all(item: Array<Evaluate>): Observable<any> {

      // var body = {
      //   email: item
      // };
      const b = this.http.post('/users/evaluate_all', item);
      const request = b.pipe(
        map((data: TokenResponse) => {

          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
      }

      // overall_result
      public overall_result(item: Array<Overall_Result>): Observable<any> {

        // var body = {
        //   email: item
        // };
        const b = this.http.post('/users/overall_result', item);
        const request = b.pipe(
          map((data: TokenResponse) => {

            return data;
          })
        );
        return request;
        }

        // individual_result
        public individual_result(item: Array<Overall_Result>): Observable<any> {

          var body = {
            email: item
          };
          const b = this.http.post('/users/individual_result', body);
          const request = b.pipe(
            map((data: TokenResponse) => {

              return data;
            })
          );
          return request;
          }


  //display batch_year...........
  public academicyear(set: Year): Observable<any> {

    var body = {
      id: set
    };
    const base = this.http.post('/users/college/batch_year', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  public audiourl(set: audio): Observable<any> {

    var body = {
      id: set
    };
    console.log(body);
    const base = this.http.post('/users/college/audiourl', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


}



